/* eslint-disable import/prefer-default-export */
export const MERCH_FORM_DESC_MAX = 500;
